import logo from "../assets/PalommaLogoWithText.svg";
import { Box } from "@chakra-ui/react";

type Props = {
  width?: number;
  height?: number;
};

const PalommaLogoWithText = ({ width, height }: Props): JSX.Element => {
  return (
    <Box maxH={height} maxW={width}>
      <img src={logo} alt="Palomma Logo" width={"100%"} />
    </Box>
  );
};

export default PalommaLogoWithText;
